// extracted by mini-css-extract-plugin
export var checkbox = "_37-0";
export var circle = "_37-3";
export var horizontalContainer = "_37-7";
export var sm = "_37-5";
export var switch0 = "_37-2";
export var switchDisabled = "_37-8";
export var switchEnabled = "_37-1";
export var textSwitchContainer = "_37-9";
export var textSwitchOption = "_37-a";
export var textSwitchOptionSelected = "_37-b";
export var verticalContainer = "_37-6";
export var xs = "_37-4";